module.exports = __webpack_public_path__ + "img/bn(1).ab1503bb.png";